import { CLEAR_JOBTYPES } from '../../constants/ActionConstants';

export const clearJobType = (jobType) => ({
    type: CLEAR_JOBTYPES,
    data: { jobType: jobType }
});